var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_656_3783",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.636719,
    y: 0.838867,
    width: 40,
    height: 40,
    fill: "#1BA397"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_656_3783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30153 30.1893V16.9328H12.1177V30.1893H9.30153ZM19.2801 30.1893V16.9328H22.0963V30.1893H19.2801ZM3.97461 35.9328V33.1167H37.2992V35.9328H3.97461ZM29.1561 30.1893V16.9328H31.9723V30.1893H29.1561ZM3.97461 14.0054V11.3474L20.6369 2.47357L37.2992 11.3474V14.0054H3.97461ZM10.3271 11.1893H30.9467L20.6369 5.69357L10.3271 11.1893Z",
    fill: "#1BA397"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.de0731c57c2f7ea7d2df7dff3cf307d9.svg";
export { ForwardRef as ReactComponent };